import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import PageBanner from "../../components/PageBanner";
import NpfTracking from "../../components/NpfTracking";
import NpfEnquiryWidget from "../../components/NpfEnquiryWidget";
import footerLogo from "../../assets/images/logos/footer-logo.png";
import "./enquire.css";

// Opened in a new tab by the site-wide "Enquire Now" sticky CTA. Hosts the
// NoPaperForms enquiry form (components/NpfEnquiryWidget) on an otherwise
// minimal page so the form gets the whole viewport.
const EnquirePage = () => {
  return (
    <>
      <NpfTracking />
      <Header parentMenu="contact" topbarEnable="enable" />
      <PageBanner
        title="Enquire Now"
        eyebrow="Admissions"
        subtitle="Share your details and our admissions team will get in touch with you."
      />
      <section className="enquire-page">
        <div className="container">
          <div className="enquire-page__card">
            <NpfEnquiryWidget height="400px" />
          </div>
        </div>
      </section>
      <Footer footerLogo={footerLogo} />
    </>
  );
};

export default EnquirePage;
